import React from 'react';
import { useSelector } from 'react-redux';
import { translatePage } from '../../../../../utils/services/translate';
import getCurrencyLabel from '../../../../../utils/helper/currencyLabel';
import './styles.scss';

const ActionButtons = ({ onProceed, onCancel, isProcessing }) => {
  const translations = useSelector(state => state.Layout.translations);
  const language = useSelector(state => state.Layout.language);
  const basket = useSelector(state => state.Order.basket);
  const project = useSelector(state => state.Project.project);

  return (
    <div className="row mt-3">
      <div className="col-12">
        <button
          className="btn btn-success w-100"
          onClick={onProceed}
          disabled={isProcessing}
        >
          {translatePage(
            translations,
            language,
            "paymentSelectionPage",
            "payButtonText"
          )}
          &nbsp;
          {basket.total} {getCurrencyLabel(language, project.currency)}
        </button>
      </div>
      <div className="col-12">
        <button
          className="btn btn-secondary w-100 mt-3"
          onClick={onCancel}
        >
          {translatePage(
            translations,
            language,
            "paymentSelectionPage",
            "cancelButton"
          )}
        </button>
      </div>
    </div>
  );
};

export default ActionButtons;